import { Component, inject, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { SharedComponents } from "../../shared.module";

@Component({
  selector: "app-progress-modal",
  standalone: true,
  imports: [...SharedComponents],
  templateUrl: "./progress-modal.component.html",
  styleUrl: "./progress-modal.component.scss",
})
export class ProgressModalComponent {
  activeModal = inject(NgbActiveModal);

  @Input()
  configs: any = {};

  @Input()
  progressText: any = "Testcase Processing";

  @Input()
  percentage: any = "3";

}
